// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fatal-error-message[data-v-7f7b8962]{position:absolute;top:50%;left:50%;transform:translateX(-50%) translateY(-50%);font-size:18px;text-align:center;font-weight:400}", ""]);
// Exports
module.exports = exports;
